import React from 'react';
import { Award, Heart, Clock } from 'lucide-react';
import { contactInfo } from '../mockData';

const AboutSection = ({ translations }) => {
  const features = [
  {
    icon: Award,
    title: translations.feature1Title,
    description: translations.feature1Desc
  },
  {
    icon: Clock,
    title: translations.feature2Title,
    description: translations.feature2Desc
  },
  {
    icon: Heart,
    title: translations.feature3Title,
    description: translations.feature3Desc
  }];


  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-brown-900 mb-4">
            {translations.aboutTitle}
          </h2>
          <div className="w-24 h-1 bg-brown-700 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <p className="!text-lg text-brown-700">
              {translations.aboutText1}
            </p>
            <p className="text-lg text-brown-700 leading-relaxed">
              {translations.aboutText2}
            </p>
            <p className="text-lg text-brown-700 leading-relaxed font-semibold">
              {translations.aboutText3}
            </p>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/asf91kaz_image.png"
                alt="Dere Pastanesi"
                className="w-full h-96 object-cover" />

            </div>
          </div>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mt-20">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center p-8 rounded-2xl bg-cream-50 hover:bg-cream-100 transition-all duration-300 hover:shadow-lg hover:scale-105">

                <div className="inline-flex items-center justify-center w-16 h-16 bg-brown-700 text-white rounded-full mb-4">
                  <Icon className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold text-brown-900 mb-3">{feature.title}</h3>
                <p className="text-brown-700">{feature.description}</p>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default AboutSection;